import React, { useEffect, useRef, useState } from 'react';
import { Col, Form, Modal, Row, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useClickAway } from 'react-use';
import { useGetRequest } from '../../../hooks/useGetRequest';

const HidePrescriptionItemModal = ({
  isShow,
  setIsShow,
  hideItems,
  setHideItems,
  leftOrRightItems,
  handleSubmit,
}) => {
  const [prescriptionItems, setPrescriptionItems] = useState([]);
  const activeOrganization = useSelector(
    (state) => state.orgReducer.organization,
  );
  console.log('hideItems', hideItems);
  const { isLoading: isLoadingItems, refetch: getPrescriptionItems } =
    useGetRequest(
      'prescriptionItems',
      'settings/prescription-item-setting?organizationId=' +
        activeOrganization.id,
      (data) => {
        setPrescriptionItems(data.items);
      },
      (e) => {
        console.log(e);
      },
    );

  useEffect(() => {
    getPrescriptionItems();
  }, []);

  const rxItemName = (itemName) => {
    if (prescriptionItems) {
      const itemNames = {
        'chief-complain': 'Chief Complain',
        'chief-complaint': 'Chief Complain',
        history: 'History',
        diagnosis: 'Diagnosis',
        'on-examination': 'On Examinations',
        investigation: 'Investigations',
        rx: 'Rx',
        rehabilitation: 'Rehabilitation',
        'follow-up': 'Follow-Up',
        advice: 'Advice',
        infertility: 'Infertility',
        'eye-glass': 'Eye-Glass',
        'special-note': 'Special Note',
        signature: 'Signature',
        predictions: 'Predictions',
        referredto: 'Referred To',
        'treatment-plan': 'Treatment To',
      };
      return itemNames[itemName];
    } else {
      return '';
    }
  };

  const handleHideItems = (item) => {
    console.log('working....', item);
    setHideItems({ ...hideItems, [item]: !hideItems[item] });
  };

  const ref = useRef(null);
  useClickAway(ref, (e) => {
    setIsShow(false);
  });

  const getLabel = () => {
    return <i className="fa fa-eye" />;
  };

  //   const allPrescriptionItems = prescriptionItems
  //     ? Object.keys(prescriptionItems).filter(
  //         (key) => prescriptionItems[key]?.enabled === true,
  //       )
  //     : [];

  const leftPrescriptionItems = Object.keys(prescriptionItems)?.filter(
    (item) => {
      if (
        prescriptionItems[item]?.enabled &&
        prescriptionItems[item]?.position === 'left'
      ) {
        return prescriptionItems[item];
      }
    },
  );
  const rightPrescriptionItems = Object.keys(prescriptionItems)?.filter(
    (item) => {
      if (
        prescriptionItems[item]?.enabled &&
        prescriptionItems[item]?.position === 'right'
      ) {
        return prescriptionItems[item];
      }
    },
  );

  const makeDefaultPrescriptionItemHide = () => {
    localStorage.setItem('hidePrescriptionItems', JSON.stringify(hideItems));
    alert('Saved');
  };

  return (
    <Modal size="lg" show={isShow}>
      <Modal.Header className="common-modal-header">
        <Col>
          <Modal.Title className="text-center">
            {' '}
            <i className="fa fa-print" /> Customized print on your Prescription
          </Modal.Title>
        </Col>
        {/* <Col md={4}></Col> */}
        <Col md={1} style={{ textAlign: 'end' }}>
          <i
            className="far fa-times-circle cursor-pointer text-danger"
            aria-hidden="true"
            onClick={() => setIsShow(false)}
          ></i>
        </Col>
      </Modal.Header>
      <Modal.Body ref={ref}>
        <Row className="mt-3">
          <Col style={{ borderRight: '1px solid black', marginBottom: '2rem' }}>
            {leftPrescriptionItems?.map(
              (item, index) =>
                rxItemName(item) && (
                  <Row key={index} className="pt-1">
                    <Col md={12} className="pl-4">
                      <span className="custom-print-label">
                        {rxItemName(item)}{' '}
                      </span>
                      {!hideItems?.[item] && (
                        <i
                          className="far fa-eye cursor-pointer"
                          style={{ color: '#228093' }}
                          onClick={(e) => handleHideItems(item)}
                        />
                      )}
                      {hideItems?.[item] && (
                        <i
                          className="far fa-eye-slash cursor-pointer"
                          style={{ color: '#228093' }}
                          onClick={(e) => handleHideItems(item)}
                        />
                      )}
                    </Col>
                  </Row>
                ),
            )}
          </Col>
          <Col>
            {rightPrescriptionItems?.map(
              (item, index) =>
                rxItemName(item) && (
                  <Row key={index} className="pt-1">
                    <Col md={12} className="pl-4">
                      <span className="custom-print-label">
                        {rxItemName(item)}{' '}
                      </span>
                      {!hideItems?.[item] && (
                        <i
                          className="far fa-eye cursor-pointer"
                          style={{ color: '#228093' }}
                          onClick={(e) => handleHideItems(item)}
                        />
                      )}
                      {hideItems?.[item] && (
                        <i
                          className="far fa-eye-slash cursor-pointer"
                          style={{ color: '#228093' }}
                          onClick={(e) => handleHideItems(item)}
                        />
                      )}
                    </Col>
                  </Row>
                ),
            )}
            <Row key={'patient-hide'} className="pt-1">
              <Col md={12} className="pl-4">
                <span className="custom-print-label">{'Patient section'} </span>
                {!hideItems?.['patient-section'] && (
                  <i
                    className="far fa-eye cursor-pointer"
                    style={{ color: '#228093' }}
                    onClick={(e) => handleHideItems('patient-section')}
                  />
                )}
                {hideItems?.['patient-section'] && (
                  <i
                    className="far fa-eye-slash cursor-pointer"
                    style={{ color: '#228093' }}
                    onClick={(e) => handleHideItems('patient-section')}
                  />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <div className="center" style={{ width: '100%' }}>
            <Button
              variant="primary"
              className="mr-1 save-button button-left-round"
              size="small"
              style={{ width: '18rem' }}
              onClick={() => makeDefaultPrescriptionItemHide()}
              // disabled={disableButtons}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-file-earmark-ruled"
                viewBox="0 0 16 16"
              >
                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5zM3 12v-2h2v2zm0 1h2v2H4a1 1 0 0 1-1-1zm3 2v-2h7v1a1 1 0 0 1-1 1zm7-3H6v-2h7z" />
              </svg>
              <span className="pl-2">Make default print</span>
            </Button>
            <Button
              variant="primary"
              className="mr-1 save-button button-right-round"
              size="small"
              style={{ width: '18rem' }}
              onClick={(e) => {
                e.preventDefault();
                setIsShow(false);
                handleSubmit('saveAndPrint');
              }}
              // disabled={disableTemplateCreateButton}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                class="bi bi-printer"
                viewBox="0 0 16 16"
              >
                <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"></path>
                <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1"></path>
              </svg>
              <span className="pl-2">Print</span>
            </Button>
          </div>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default HidePrescriptionItemModal;
